<template>
    <div id="cms-search-library">
        <div v-if="header" class="top-banner">
            <div>&nbsp;</div>
        </div>

        <!-- newland-begin -->
        <div v-if="header" v-html="header" />
        <!-- newland-end -->

        <div class="cms-search-library">

            <div>
                <!-- top -->
                <div>
                    <div v-if="!header" class="top-title">搜索</div>
                    <div class="searchtiaojian nl-searchtiaojian">
                        <!-- <div>
              <a :href="systemData.pcaddress">
              <img :src="logoUrl" style="max-width: 400px;" alt="图片">
            </a>
            </div> -->
                        <div>
                            <div class="rightsearchinput nl-rightsearchinput">
                                <input
                                    type="text"
                                    class="topsearch-input nl-topsearch-input"
                                    v-model="searchBasicForm.keyword"
                                    placeholder="请输入关键词"
                                />
                                <input
                                    type="button"
                                    value="搜索"

                                    class="btnSearch nl-btnSearch"
                                    :class="themeButton"
                                    :style="{
                                        color: '#fff',
                                        backgroundColor: themeColor + '!important',
                                    }"
                                    @click="searchBasic"
                                />
                                <div style="margin: 0 10px; cursor: pointer">
                                    <div @click="advancSerach">高级搜索</div>
                                </div>
                            </div>
                            <!--              <div class="hotwordstyle">-->
                            <!--                <label class="fontWeight">热搜词：</label>-->
                            <!--                <span-->
                            <!--                  v-for="(item, index) in hotwordData"-->
                            <!--                  :key="index"-->
                            <!--                  class="cursor-pointer"-->
                            <!--                  @click="searchBasic(item.word)">-->
                            <!--                  {{ item.word }}-->
                            <!--                </span>-->
                            <!--              </div>-->
                        </div>
                    </div>
                </div>

                <!-- 索引库 -->
                <el-menu
                    class="el-menu-demo nl-menu"
                    mode="horizontal"
                    @select="setIndex"
                    text-color="#222222"
                    active-text-color="#005ec4"
                >
                    <el-menu-item
                        v-for="item in database"
                        :key="item.searchid"
                        :index="item.searchid"
                    >
                        {{ item.searchname }}
                    </el-menu-item>
                </el-menu>

                <!-- 搜索结果 -->
                <div class="search-result">
                    <!-- 搜索条件 -->
                    <div class="search-condition" style="margin: 15px 0 10px;">
                        <div class="nl-gray" style="min-width: 100px;">
                            <span v-if="!loading">相关结果{{ resultDatatotal }}条</span>
                        </div>
                        <div v-if="isShowtool">
                   
                            <span class="fontWeight">排序：</span>
                            <span
                                class="cursor-pointer"
                                :class="
                                    searchForm.orderBy === 'SCORE' ? 'nl-theme' : 'nl-gray'
                                "
                                @click="setOrder('SCORE')"
                            >
                                按相关度
                            </span>
                            <span
                                class="cursor-pointer"
                                :class="searchForm.orderBy === 'TIME' ? 'nl-theme' : 'nl-gray'"
                                @click="setOrder('TIME')"
                            >
                                按日期
                            </span>
                            <span class="fontWeight">搜索位置：</span>
                            <span
                                class="cursor-pointer"
                                :class="!this.searchForm.fields ? 'nl-theme' : 'nl-gray'"
                                @click="setFields('all')"
                            >
                                全文
                            </span>
                            <span
                                class="cursor-pointer"
                                :class="this.fieldsactive == 'TITLE' ? 'nl-theme' : 'nl-gray'"
                                @click="setFields('title')"
                            >
                                标题
                            </span>
                            <span
                                class="cursor-pointer"
                                :class="
                                    this.fieldsactive == 'AUTHOR' ? 'nl-theme' : 'nl-gray'
                                "
                                @click="setFields('author')"
                            >
                                作者
                            </span>
                            <span
                                class="cursor-pointer"
                                :class="
                                    this.fieldsactive == 'EDITORS' ? 'nl-theme' : 'nl-gray'
                                "
                                @click="setFields('editors')"
                            >
                                编辑
                            </span>
                            <span
                                class="cursor-pointer"
                                :class="
                                    this.fieldsactive == 'ORIGIN' ? 'nl-theme' : 'nl-gray'
                                "
                                @click="setFields('source')"
                            >
                                来源
                            </span>
                            <el-popover placement="bottom" width="100" v-model="propTime">
                                <div class="proptimediv" @click="setDateRange('all')">时间不限</div>
                                <div class="proptimediv" @click="setDateRange('week')">一周内</div>
                                <div class="proptimediv" @click="setDateRange('month')">一月内</div>
                                <div class="proptimediv" @click="setDateRange('year')">一年内</div>
                                <div>自定义</div>
                                <div>
                                    <span>从</span>
                                    <el-date-picker
                                        v-model="searchTimeForm.after"
                                        size="small"
                                        type="date"
                                        placeholder="选择日期"
                                    >
                                    </el-date-picker>
                                    <span>至</span>
                                    <el-date-picker
                                        v-model="searchTimeForm.before"
                                        size="small"
                                        type="date"
                                        placeholder="选择日期"
                                    >
                                    </el-date-picker>
                                </div>
                                <div style="text-align: right; margin: 0">
                                    <el-button
                                        type="primary"
                                        size="mini"
                                        @click="setDateRange('custom')"
                                        >确定</el-button
                                    >
                                </div>
                                <el-button style="border: 0" slot="reference">
                                    <span>{{ timetext }}</span>
                                    <i class="el-icon-arrow-down"></i>
                                </el-button>
                            </el-popover>
                        </div>
                        <div @click="isShowtool = !isShowtool">
                            <div class="cursor-pointer" v-if="isShowtool">
                                <i class="el-icon-arrow-up"></i>
                                收起工具
                            </div>
                            <div class="cursor-pointer" v-else>
                                <i class="el-icon-arrow-down"></i>
                                搜索工具
                            </div>
                        </div>
                    </div>
                    <div v-if="resultDatatotal === 0">
                        <div
                            v-if="notSearched"
                            v-loading="loading"
                            element-loading-text="正在查询，请稍后"
                            element-loading-fullscreen="fullscreen"
                            style="height: 10rem; position: sticky; z-index: 0"
                        ></div>
                        <div
                            v-else
                            style="font-size: 14px; font-weight: 600; line-height: 2em; margin: 2em"
                            v-loading="loading"
                            element-loading-text="正在查询，请稍后"
                            element-loading-fullscreen="fullscreen"
                        >
                            很抱歉！未能搜索到您想要的内容
                            <br />
                            建议您：
                            <br />
                            1、看看输入的文字是否有错误
                            <br />
                            2、去掉可能不必要的词或条件
                        </div>
                    </div>
                    <!-- 数据展示 -->
                    <div class="dataList" v-else>
                        <div
                            class="dataListTag"
                            v-loading="loading"
                            element-loading-text="正在查询，请稍后"
                            element-loading-fullscreen="fullscreen"
                            style="position: sticky; z-index: 0"
                        >
                            <!-- 推荐图 -->
                            <div
                                v-if="recommendData.length !== 0"
                                style="
                                    margin: 0 0 20px;
                                    border: 1px solid #eee;
                                    border-radius: 5px;
                                    padding: 6px;
                                    margin-bottom: 30px;
                                "
                            >
                                <el-carousel height="240px">
                                    <el-carousel-item
                                        v-for="item in recommendData"
                                        :key="item.recommendid"
                                    >
                                        <a :href="item.url" target="_blank"
                                            ><img :src="item.picurl" style="width: 100%" alt=""
                                        /></a>
                                    </el-carousel-item>
                                </el-carousel>
                            </div>
                            <!-- list -->
                            <div v-for="(item, index) in resultDatalist" :key="index" style="margin-bottom:15px;">
                                <div class="dataListTag-child nl-dataListTag-child">
                                    <!-- 搜因库名称 -->
                                    <div
                                        class="backTitle"
                                        >{{ item.channelName }}</div
                                    >
                                    <a
                                        :href="`${item.type !== '6' ? item.path : item.link}`"
                                        target="_blank"
                                        class="a_dataTile"
                                        v-html="calcTitle(item)"
                                    ></a>
                                </div>
                                <div class="dataListTag-pic">
                                    <div v-if="item.iscode != 1">
                                        <div v-if="false">
                                            <img src="#" alt="图片" class="imgstyle" />
                                        </div>
                                        <div>
                                            <div
                                                class="dataListTag-child dataListTagTitle nl-dataListTag-child"
                                                v-html="item.text.substring(0, 200)"
                                                style="color:#666666;"
                                            ></div>
                                            <div class="dataListTag-child" style="color:#666666;">
                                                {{ item.siteName }}-{{ item.publishedAt }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="item.iscode == 1" v-html="item.maincode"></div>
                                </div>
                            </div>
                            <el-pagination
                                background
                                layout="total, sizes, prev, pager, next, jumper"
                                :page-sizes="[10, 20, 30, 50]"
                                :current-page="searchForm.current"
                                :page-size="searchForm.size"
                                :total="resultDatatotal"
                                @current-change="onCurrentChange"
                                @size-change="onSizeChange"
                            />
                        </div>

                        <div class="rightShowes">
                            <div>
                                <div style="font-size: 18px; margin-bottom: 10px;font-weight:bold;">
                                    <span >{{ searchText }}</span>
                                    <span>的智能推荐</span>
                                </div>
                                <div
                                    v-for="(item, index) in caprecomData"
                                    :key="index"
                                    style="margin: 15px 0"
                                >
                                    <div v-if="item.contents.length !== 0">
                                        <label class="fontWeight">{{
                                            item.index.searchname
                                        }}</label>
                                        <div v-for="(item, index) in item.contents" :key="index">
                                            <a
                                                :href="item.path"
                                                target="_blank"
                                                class="nl-link"
                                            >
                                                {{ item.title }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="searchHistory.length !== 0">
                                <div class="fontWeight">历史搜索</div>
                                <div style="padding:0 0 10px">
                                    <div
                                        class="nl-link"
                                        v-for="(item, index) in searchHistory"
                                        :key="index"
                                        @click="searchBasic(item)"
                                    >
                                        {{ item }}
                                    </div>
                                </div>
                                <el-button @click="clearHistory" size="small"
                                    >清空搜索历史</el-button
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 版权 -->
        <!-- <div class="emptydiv"></div>
        <div class="cms-footer" v-html="systemData.copyright"></div> -->

        <!-- 高级搜索 -->
        <el-dialog :visible="searchDialog">
            <div class="search-dialog-title">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="高级搜索" name="first"></el-tab-pane>
                </el-tabs>
                <i
                    class="el-icon-close"
                    style="cursor: pointer; font-size: 25px"
                    @click="closedialog"
                ></i>
            </div>
            <el-form
                ref="searchForm"
                label-width="80px"
                :model="searchAdvancedForm"
                v-if="activeName === 'first'"
            >
                <el-form-item label="搜索结果:" prop="keywords">
                    <div>
                        <span class="setTitleleft">包含以下全部的关键词</span>
                        <el-input
                            v-model="searchAdvancedForm.must"
                            size="small"
                            style="width: 300px"
                            maxlength="100"
                        />
                    </div>
                    <div>
                        <span class="setTitleleft">包含以下完整的关键词</span>
                        <el-input
                            v-model="searchAdvancedForm.must_phrase"
                            size="small"
                            style="width: 300px"
                            maxlength="100"
                        />
                    </div>
                    <div>
                        <span class="setTitleleft">包含以下任意一个关键词</span>
                        <el-input
                            v-model="searchAdvancedForm.should"
                            size="small"
                            style="width: 300px"
                            maxlength="100"
                        />
                    </div>
                    <div>
                        <span class="setTitleleft">不包含以下关键词</span>
                        <el-input
                            v-model="searchAdvancedForm.not"
                            size="small"
                            style="width: 300px"
                            maxlength="100"
                        />
                    </div>
                </el-form-item>
                <el-form-item label="时间范围:" prop="rangeType">
                    <el-radio v-model="searchAdvancedForm.rangeType" label="all">全部</el-radio>
                    <el-radio v-model="searchAdvancedForm.rangeType" label="year">一年内</el-radio>
                    <el-radio v-model="searchAdvancedForm.rangeType" label="month">一月内</el-radio>
                    <el-radio v-model="searchAdvancedForm.rangeType" label="week">一周内</el-radio>
                    <el-radio v-model="searchAdvancedForm.rangeType" label="custom"
                        >自定义</el-radio
                    >
                    <span v-if="searchAdvancedForm.rangeType === 'custom'"
                        >从
                        <el-date-picker
                            v-model="searchAdvancedForm.rangeStart"
                            size="small"
                            type="date"
                            placeholder="选择日期"
                        >
                        </el-date-picker>
                        <span>至</span>
                        <el-date-picker
                            v-model="searchAdvancedForm.rangeEnd"
                            size="small"
                            type="date"
                            placeholder="选择日期"
                        >
                        </el-date-picker>
                    </span>
                </el-form-item>
                <el-form-item label="排序方式:" prop="orderBy">
                    <el-radio v-model="searchAdvancedForm.orderBy" label="SCORE"
                        >按相关度排序</el-radio
                    >
                    <el-radio v-model="searchAdvancedForm.orderBy" label="TIME"
                        >按时间排序</el-radio
                    >
                </el-form-item>
                <el-form-item label="搜索位置:" prop="fieldType">
                    <el-radio v-model="searchAdvancedForm.fieldType" label="all">任何地方</el-radio>
                    <el-radio v-model="searchAdvancedForm.fieldType" label="title">仅标题</el-radio>
                    <el-radio v-model="searchAdvancedForm.fieldType" label="author"
                        >仅作者</el-radio
                    >
                    <el-radio v-model="searchAdvancedForm.fieldType" label="editors"
                        >仅编辑</el-radio
                    >
                    <el-radio v-model="searchAdvancedForm.fieldType" label="source"
                        >仅来源</el-radio
                    >
                </el-form-item>
                <div class="btngjsearch">
                    <input
                        type="button"
                        value="开始搜索"
                        class="btnSearch"
                        :class="themeButton"
                        :style="{
                            width: '150px',
                            color: '#fff',
                            backgroundColor: themeColor + '!important',
                        }"
                        @click="searchAdvanced"
                    />
                </div>
            </el-form>
        </el-dialog>
        <template>
            <el-backtop />
        </template>

        <!-- newland-begin -->
        <div v-html="footer" />
        <!-- newland-end -->

    </div>


</template>

<script>
import { fetch_GET, fetch_POST } from "@/interfaces/request";


export default {
    name: "Search",
    data() {
        return {
            loading: false,
            notSearched: true,
            params: {},
            recommendData: [],
            timetext: "时间不限",
            isShowtool: true, //是否隐藏搜索工具
            form: {
                region: "1",
            },
            resultDatalist: [], //搜索列表数据
            resultDatatotal: 0, //搜索结果多少条数据
            systemData: {},
            hotwordData: [],
            database: [{ searchid: "", searchname: "全部" }],
            searchText: "",
            // 高级搜索弹框
            searchDialog: false,
            propTime: false,
            activeName: "first",
            //智能推荐
            caprecomData: [],
            capRecomtPage: {
                indexes: [],
                keyword: "平台",
                site: "A001",
            },

            // 基本搜索表单
            searchBasicForm: {
                keyword: "",
            },
            // 高级搜索表单
            searchAdvancedForm: {
                must: "",
                must_phrase: "",
                should: "",
                not: "",
                fieldType: "all",
                orderBy: "TIME",
                rangeType: "all",
                rangeStart: null,
                rangeEnd: null,
            },
            // 时间筛选表单
            searchTimeForm: {
                after: null,
                before: null,
            },
            // 搜索条件
            searchForm: {
                site: "A001",
                indexes: null,
                keywords: {
                    should: "",
                    must: "",
                    not: "",
                },
                range: null,
                orderBy: "TIME",
                fielded: "text",
                timeformat: "1",
                current: 1,
                size: 10,
            },
            // 搜索历史
            searchHistory: [],
            fields: null,
            fieldsactive: null,
            header: "",
            footer: "",
        };
    },
    created() {
        // 初始化查询参数
        location.search
            .substring(1)
            .split("&")
            .forEach((item) => {
                const pair = item.split("=");
                this.params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            });

        // 设置查询条件
        this.searchBasicForm.keyword = this.params.searchWord;
        this.getData();

        // 初始化搜索历史
        const json = localStorage.getItem("histories");
        this.searchHistory = json?.length ? JSON.parse(json) : [];

        //console.log("外面", this.header);
        //this.header = "<div>1357911</div>";
    },
    computed: {
        cookie() {
            const items = document.cookie.split(";");
            let map = {};
            items.forEach((item) => {
                const pair = item.trim().split("=");
                map[pair[0]] = pair[1];
            });
            return map;
        },
        themeColor() {
          
            // if (this.systemData.styletype === "0") return "#2f5397";
            // if (this.systemData.styletype === "1") return "rgb(96, 125, 139)";
            // if (this.systemData.styletype === "2") return "rgb(25, 185, 85)";
            // if (this.systemData.styletype) return this.systemData.styletype;
            return "#005ec4";
        },
        themeButton() {
            if (this.systemData.styletype === "0") return "btnSearch0";
            if (this.systemData.styletype === "1") return "btnSearch1";
            if (this.systemData.styletype === "2") return "btnSearch2";
            if (this.systemData.styletype) return "";
            return "btnSearch3";
        },
        logoUrl() {
            return this.$config.BASE_URL + this.systemData.logourl;
        },
    },
    methods: {
        // 获取系统数据
        async getDynamicContent() {
            console.log(JSON.stringify(this.systemData));

            // 第一步：先加载动态的CSS
            if (this.systemData.dynamicCssUrl){
                let that = this;
                this.systemData.dynamicCssUrl.split(",").forEach(url => that.loadCss(url));
            }

            // 第二步：加载动态的头部
            if (this.systemData.dynamicHeaderUrl){
                console.log("请求头部开始");
                const header = await fetch_GET(this.systemData.dynamicHeaderUrl, {

                });

                console.log("请求头部结束", header);
                this.header = header.data;
                console.log("请求头部结束", this.header);
            }

            // 第三步：加载动态的底部
            if (this.systemData.dynamicFooterUrl){
                const footer = await fetch_GET(this.systemData.dynamicFooterUrl, {

                            });
                console.log("请求底部结束", footer);
                this.footer = footer.data;
                console.log("请求底部结束", this.footer);
            }

            // 第四步：加载动态的JS
            // JS放到最后执行，是由于有一些菜单的展示，要求先有<div>才能执行JS
            if (this.systemData.dynamicJsUrl){
                let that = this;
                setTimeout(function(){
                    that.systemData.dynamicJsUrl.split(",").forEach(url => that.loadScript(url));
                }, 1000);
            }
        },
        async getData() {
            const systemresp = await fetch_GET(`/api/search/getSearchConfigByWebappId`, {
                id: this.params.siteCode,
            });
            if (systemresp.data.code === 0) {
                this.systemData = systemresp.data.data;
                document.title = this.systemData.systitle;
            } else {
                this.$message("系统请求失败");
            }
            // 获取索引库数据
            const resp = await fetch_GET(`/api/search/getSearchMainList`, {
                current: 1,
                size: 99,
                webappcode: this.params.siteCode,
            });

            if (resp.data.code === 0) {
                this.database.push(...resp.data.data);

                this.searchBasic();
            } else {
                this.$message("索引库请求失败");
            }

            // 获取热搜词数据
            const hotresp = await fetch_GET(`/api/search/getHotwordsForSearch`, {
                webappcode: this.params.siteCode,
            });
            if (hotresp.data.code === 0) {
                this.hotwordData = hotresp.data.data;
            } else {
                this.$message("热搜词请求失败");
            }

            this.getDynamicContent();
        },

        // 获取推荐图数据
        async recommendfun(val) {
            const recomresp = await fetch_GET(`/api/search/getSearchRecommengPicPageList`, {
                current: 1,
                size: 99,
                searchid: val,
                useflag: true,
            });
            if (val) {
                if (recomresp.data.code === 0) {
                    this.recommendData = recomresp.data.data.records;
                } else {
                    this.$message("推荐图请求失败");
                }
            } else {
                this.recommendData = [];
            }
        },

        // 高级搜索弹窗
        advancSerach() {
            this.searchDialog = true;
            this.activeName = "first";
        },

        closedialog() {
            this.searchDialog = false;
        },

        format(string) {
            if (!string) return "";

            const intl = new Intl.DateTimeFormat("zh", {
                hour12: false,
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            });

            const date = string instanceof Date ? string : new Date(string);

            return intl.format(date).replace(/\//g, "-");
        },

        // ======================
        // 数据处理
        // ======================

        calcDateRange(type, start, end) {
            if (type === "all") return null;

            const now = new Date();
            let before, after;
            switch (type) {
                case "year":
                    before = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
                    after = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
                    return { before, after };
                case "month":
                    before = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
                    after = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
                    return { before, after };
                case "week":
                    before = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
                    after = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);
                    return { before, after };
                case "day":
                    before = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
                    after = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
                    return { before, after };
                case "custom":
                    return {
                        after: start,
                        before: end,
                    };
            }
        },

        calcDateRangeLabel(type) {
            switch (type) {
                case "year":
                    return "一年内";
                case "month":
                    return "一月内";
                case "week":
                    return "一周内";
                case "day":
                    return "一天内";
                case "custom":
                    return "自定义";
                default:
                    return "全部";
            }
        },

        calcTitle(doc) {
            const highlight = /<span style="color: red">.*<\/span>/;

            if (highlight.test(doc.shortTitle)) {
                return doc.shortTitle;
            }
            if (highlight.test(doc.title)) {
                return doc.title;
            }
            if (highlight.test(doc.quoteTitle)) {
                return doc.quoteTitle;
            }
            if (highlight.test(doc.subTitle)) {
                return doc.subTitle;
            }
            return doc.shortTitle || doc.title;
        },

        // ======================
        // 搜索
        // ======================

        // 筛选索引库
        setIndex(key) {
            if (!key) {
                this.searchForm.indexes = null;
            } else {
                this.capRecomtPage.indexes = this.searchForm.indexes = [key];
            }
            this.recommendfun(key);
            this.search();
        },

        // 筛选字段
        setFields(val) {
            switch (val) {
                case "all":
                    this.searchForm.fields = null;
                    this.fieldsactive = null;
                    break;
                case "title":
                    this.searchForm.fields = ["TITLE"];
                    this.fieldsactive = "TITLE";
                    break;
                case "author":
                    this.searchForm.fields = ["AUTHOR"];
                    this.fieldsactive = "AUTHOR";
                    break;
                case "source":
                    this.searchForm.fields = ["ORIGIN"];
                    this.fieldsactive = "ORIGIN";
                    break;
                case "editors":
                    this.searchForm.fields = ["EDITORS"];
                    this.fieldsactive = "EDITORS";
                    break;
            }
            this.search();
        },

        // 筛选时间
        setDateRange(type) {
            this.timetext = this.calcDateRangeLabel(type);
            this.searchForm.range = this.calcDateRange(
                type,
                this.searchTimeForm.after,
                this.searchTimeForm.before
            );
            this.searchTimeForm = this.searchForm.range ?? {
                after: null,
                before: null,
            };

            this.search();
            this.propTime = false;
        },

        // 排序
        setOrder(val) {
            this.searchForm.orderBy = val;
            this.search();
        },

        // 切换页码
        onCurrentChange(val) {
            this.searchForm.page = val;
            this.search();
        },

        // 切换每页条数
        onSizeChange(val) {
            this.searchForm.page = 1;
            this.searchForm.size = val;
            this.search();
        },

        // 基本搜索
        searchBasic(keyword) {
            if (!this.searchBasicForm.keyword && !keyword?.length) {
                if (!document.querySelector(".el-message")) this.$message("请输入关键词");
                return;
            }

            if (keyword?.length) {
                this.searchBasicForm.keyword = keyword;
            }

            // 构造查询条件
            this.searchForm = {
                site: this.params.siteCode,
                indexes: null,
                keywords: `+"${this.searchBasicForm.keyword.trim()}"`,
                fields: null,
                range: null,
                orderBy: "TIME",
                current: 1,
                size: 10,
            };

            // 更新回显信息
            this.timetext = this.calcDateRangeLabel("all");
            this.searchTimeForm = {
                after: null,
                before: null,
            };
            this.searchText = this.searchBasicForm.keyword;

            // 更新 url 参数
            const params = new URLSearchParams(location.search);
            params.set("searchWord", this.searchText);
            const newUrl = `${location.origin}${location.pathname}?${params}`;
            history.pushState(undefined, location.title, newUrl);

            // 清理高级搜索
            this.searchAdvancedForm = {
                must: "",
                must_phrase: "",
                should: "",
                not: "",
                fieldType: "all",
                orderBy: "TIME",
                rangeType: "all",
                rangeStart: null,
                rangeEnd: null,
            };

            // 执行搜索
            this.search();
            this.saveHistory(this.searchBasicForm.keyword);
        },

        // 高级搜索
        searchAdvanced() {
            if (
                !this.searchAdvancedForm.should &&
                !this.searchAdvancedForm.must &&
                !this.searchAdvancedForm.must_phrase
            ) {
                return this.$message("请输入包含关键词");
            }

            // 构建查询语句
            const queries = [];
            if (this.searchAdvancedForm.must) {
                queries.push("+" + this.searchAdvancedForm.must.trim());
            }
            if (this.searchAdvancedForm.must_phrase) {
                queries.push('+"' + this.searchAdvancedForm.must_phrase.trim() + '"');
            }
            if (this.searchAdvancedForm.should) {
                queries.push(this.searchAdvancedForm.should.trim());
            }
            if (this.searchAdvancedForm.not) {
                queries.push("-" + this.searchAdvancedForm.not.trim());
            }

            if (this.searchAdvancedForm.fieldType === "all") {
                this.fields = null;
            }
            if (this.searchAdvancedForm.fieldType === "title") {
                this.fields = ["TITLE", "SUB_TITLE", "SHORT_TITLE", "QUOTE_TITLE"];
            }
            if (this.searchAdvancedForm.fieldType === "author") {
                this.fields = ["AUTHOR"];
            }
            if (this.searchAdvancedForm.fieldType === "source") {
                this.fields = ["ORIGIN"];
            }
            if (this.searchAdvancedForm.fieldType === "editors") {
                this.fields = ["EDITORS"];
            }
            // 构造查询条件
            this.searchForm = {
                site: this.params.siteCode,
                indexes: null,
                keywords: queries.join(" AND "),
                fields: this.fields,
                range: this.calcDateRange(
                    this.searchAdvancedForm.rangeType,
                    this.searchAdvancedForm.rangeStart,
                    this.searchAdvancedForm.rangeEnd
                ),
                orderBy: this.searchAdvancedForm.orderBy,
                current: 1,
                size: 10,
            };

            // 更新回显信息
            this.timetext = this.calcDateRangeLabel(this.searchAdvancedForm.rangeType);
            this.searchTimeForm = {
                after: this.searchAdvancedForm.rangeStart,
                before: this.searchAdvancedForm.rangeEnd,
            };
            this.searchText = "高级搜索";

            // 清理普通搜索
            this.searchBasicForm.keyword = "";

            // 执行搜索
            this.search();
            this.closedialog();
        },

        // 搜索
        async search() {
            this.loading = true;

            const resp = await fetch_POST(`/api/search/query`, this.searchForm);
            if (resp.data.code === 0) {
                this.loading = false;
                this.resultDatalist = resp.data.data.results;
                this.resultDatalist.forEach((item) => {
                    item.publishedAt = this.format(item.publishedAt);
                });
                this.resultDatatotal = resp.data.data.total;
                this.updateRecommend();
            } else {
                this.$message("请求失败");
            }
            this.notSearched = false;
        },

        // 智能推荐
        async updateRecommend() {
            if (!this.searchForm.keywords) return;
            const capres = await fetch_POST(`/api/search/queryForRecommend`, {
                site: this.params.siteCode,
                indexes: this.searchForm.indexes,
                keyword: this.searchForm.keywords,
            });
            if (capres.data.code === 0) {
                this.caprecomData = capres.data.data;
            } else {
                this.$message("智能推荐请求失败");
            }
        },

        // 保存搜索历史
        saveHistory(keyword) {
            if (keyword && !this.searchHistory.includes(keyword)) {
                this.searchHistory.push(keyword);
                localStorage.setItem("histories", JSON.stringify(this.searchHistory));
            }
        },

        // 清除搜索历史
        clearHistory() {
            this.$confirm("确定要清空搜索历史吗", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.searchHistory = [];
                localStorage.removeItem("histories");
            });
        },

        loadScript(url) {
          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = url;

          // 将 <script> 元素添加到 <head> 或者 <body> 中
          document.head.appendChild(script);
        },

        loadCss(url) {
          var style = document.createElement('link');
          style.href = url;
          style.rel = 'stylesheet';
          style.type = 'text/css';
          document.getElementsByTagName('HEAD').item(0).appendChild(style);
        }
    },
};
</script>

<style>
#cms-search-library  .headheight{
    background:white;
}
.top-banner {
    background: white;
    margin: 0 0 0 0;
    padding: 0 0 0 0;
    height: 110px;
}

.top-title {
    text-align: center;
    color: #000000;
    font-weight: bold;
    font-size: 26px;
    margin: 30px 0 30px;
}
.nl-searchtiaojian{
  padding-bottom:60px;
}
.nl-rightsearchinput {
    border-radius: 30px;
    padding: 5px;
    border: solid 1px #f5f5f5;
}
.nl-topsearch-input {
    border: none;
    border-radius: 30px;
    width: 458px;
    outline:none;
    font-size:18px;
}

.nl-btnSearch {
    width: 72px;
    background-color: #005ec4;
    border-radius: 25px;
    color: #ffffff;
}
.nl-dataListTag-child{
  margin-bottom:5px;
}
.nl-menu li{
  font-weight: bold;
  font-size:18px;
}
.nl-theme{
  color: #005ec4;
  font-weight: bold;
}
.nl-link{
  color:#666;
  margin: 10px 0;
  display: block;
}
.nl-link:hover{
  color:#005ec4;
}
.nl-gray{
  color:#666;
}
.el-menu-demo {
    position: sticky;
    top: 0;
    z-index: 1;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
}

.a_dataTile {
    color: #222;
    line-height: 1.5;
    font-size: 15px;
    font-weight: bold;
}
.a_dataTile:hover{
  color: #005ec4;
}
.backTitle {
    /* background: #2f5397; */
    color:#222222;
    font-size: 18px;
    /* padding: 2px 10px; */
    font-weight: bold;
    padding-bottom:15px;
}

.el-dropdown {
    color: #999;
    cursor: pointer;
}

.el-input__inner,
.el-button {
    border-radius: 0;
}

.el-dialog {
    margin-top: 0 !important;
    width: 100%;
}

.el-dialog__header {
    display: none;
}

.el-dialog__body {
    padding: 0;
}

.el-form-item {
    max-width: 1100px;
    margin: auto;
}

.el-form-item__label {
    font-weight: 700;
    color: #333;
}

.el-tabs--top {
    height: 40px;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 130px;
    margin: 8px 0;
}
</style>
